// API Configuration
const isDevelopment = process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';
export const API_BASE_URL = isDevelopment
  ? 'http://localhost:7860'
  : (process.env.REACT_APP_API_URL || 'https://conditional-private-intake-agent.vercel.app');

// API endpoints
export const API_ENDPOINTS = {
  // Kernels
  submitKernel: `${API_BASE_URL}/api/kernels`,
  getKernel: (id) => `${API_BASE_URL}/api/kernels/${id}`,
  getAllKernels: `${API_BASE_URL}/api/kernels`,

  // Agents (Private Intake only - Public Agent is separate service)
  triggerIntakeAgent: (id) => `${API_BASE_URL}/api/agents/intake/${id}`,

  // Note: PDF upload endpoint removed - text extraction now done client-side
};

// Polling configuration
export const POLLING_CONFIG = {
  interval: 1000, // 1 second
  maxAttempts: 60, // 1 minute max
};
